import { versionString } from 'src/components/base-components/Version/Version';
import { APP_API_VERSION } from 'src/utils/constants';
import HttpClient from './http';

const reportProblem = (error: any): Promise<any> => {
  const user: any = localStorage.getItem('user');
  const userInfo = user ? JSON.parse(user).id : 'Unauthorised user';
  const userAgent = window.navigator.userAgent;
  const timeUTC = new Date().toISOString();

  const userAgentStr = `userAgent -> ${userAgent} `;
  const userInfoStr = `userInfo -> ${userInfo} `;
  const errorStackStr = `stack -> ${error?.stack} `;
  const errorMessageStr = `errorMessage -> ${error?.message} `;
  const errorAdditionalMessageStr = error?.additionalMessage
    ? `errorAdditionalMessage -> ${error?.additionalMessage} `
    : '';
  const timeStr = `timeUTC -> ${timeUTC} `;
  const versionStr = `version -> ${versionString} `;

  const message =
    userAgentStr + userInfoStr + errorStackStr + errorMessageStr + errorAdditionalMessageStr + timeStr + versionStr;

  return HttpClient.post(
    {
      path: `${APP_API_VERSION}/sendWarningEmail`,
      baseURL: process.env.REACT_APP_REMOTE as string,
    },
    {
      message,
    },
    false
  );
};

export { reportProblem };
